module.exports = __webpack_public_path__ + "img/banner_1.02699ba8.jpg";